// Regions of the /taux-pret-immobilier filter: the `value` slugs must stay aligned with LoanRegionEnum on the back end

export interface RegionOption {
    value: string
    label: string
}

const REGIONS: RegionOption[] = [
    { value: "auvergne-rhone-alpes", label: "Auvergne-Rhône-Alpes" },
    { value: "bourgogne-franche-comte", label: "Bourgogne-Franche-Comté" },
    { value: "bretagne", label: "Bretagne" },
    { value: "centre-val-de-loire", label: "Centre-Val de Loire" },
    { value: "corse", label: "Corse" },
    { value: "grand-est", label: "Grand Est" },
    { value: "hauts-de-france", label: "Hauts-de-France" },
    { value: "ile-de-france", label: "Île-de-France" },
    { value: "normandie", label: "Normandie" },
    { value: "nouvelle-aquitaine", label: "Nouvelle-Aquitaine" },
    { value: "occitanie", label: "Occitanie" },
    { value: "pays-de-la-loire", label: "Pays de la Loire" },
    { value: "provence-alpes-cote-d-azur", label: "Provence-Alpes-Côte d'Azur" },
    { value: "guadeloupe", label: "Guadeloupe" },
    { value: "martinique", label: "Martinique" },
    { value: "guyane", label: "Guyane" },
    { value: "la-reunion", label: "La Réunion" },
    { value: "mayotte", label: "Mayotte" },
]

export const NATIONAL_REGION_VALUE = ""

export const REGION_OPTIONS: RegionOption[] = [
    { value: NATIONAL_REGION_VALUE, label: "France entière" },
    ...[...REGIONS].sort((a, b) => a.label.localeCompare(b.label, "fr")),
]
